<template>
  <div>
    <dialogos-app ref="dialogos" :dialogos="dialogos" :atrasVisible="false" :adelanteVisible="false"></dialogos-app>
    <actividad-unica-resp-app :preguntas="require('../../assets/Modulo 3/diapositiva-12.json')" @resultado="validarResultado" @reintentar="$refs.dialogos.saltarAlDialogo(0)"></actividad-unica-resp-app>

    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 12',
    'Modulo 1/AUDIO 15',
    'Modulo 1/AUDIO 14',
    'Modulo 1/AUDIO 13.2',
    'Modulo 1/AUDIO 13.1',
    'Modulo 1/AUDIO 15.1',
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "Es hora de evaluar lo que aprendiste. Las siguientes preguntas son de selección múltiple única respuesta. <span class='instruccion'>Selecciona la opción que consideres correcta.</span> Tu objetivo es llenar completamente el barril de petróleo.",
        "¡Excelente! Has comprendido perfectamente los contenidos del módulo, has ganado tu trofeo de oro, ¡Muy bien!",
        "¡Muy buen trabajo!, te has ganado un trofeo de plata, sigue adelante aprendiendo más.",
        "Bronce, no está mal pero pudo ser mejor.",
        "Lo siento, debes responder de nuevo a las preguntas, solo tienes este intento, para obtener un trofeo.",
        "Lo siento, no has obtenido ningún trofeo"
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  methods: {
    validarResultado(res, intentos){
      if(intentos > 0 || res != 'nada'){
        this.$store.commit('nextShow', true)
      }
      switch(res){
        case 'oro': 
          this.$refs.dialogos.saltarAlDialogo(1);
          this.$refs.audioPlayer.playAudio(1);
          break;
        case 'plata': 
          this.$refs.dialogos.saltarAlDialogo(2);
          this.$refs.audioPlayer.playAudio(2);
          break;
        case 'bronce': 
          this.$refs.dialogos.saltarAlDialogo(3);
          this.$refs.audioPlayer.playAudio(3);
          break;
        case 'nada': 
          if(intentos > 0){
            this.$refs.dialogos.saltarAlDialogo(5);
            this.$refs.audioPlayer.playAudio(5);
          }else{
            this.$refs.dialogos.saltarAlDialogo(4);
            this.$refs.audioPlayer.playAudio(4);
          }
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
